import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

function EmployeesList({ employees, onCycle, setEmployeeData, activeChips }) {
    const [itemsToShow, setItemsToShow] = useState(12);
    const [isExpanded, setIsExpanded] = useState(false);

    const showMore = (count) => {
        if (itemsToShow === count) {
            setItemsToShow(employees.length);
            setIsExpanded(true);
        } else {
            setItemsToShow(count);
            setIsExpanded(false);
        }
    };

    useEffect(() => {
        if (activeChips.length && employees.length >= 8) {
            setItemsToShow(8);
        } else {
            setItemsToShow(12);
            setIsExpanded(false);
        }
    }, [activeChips]);

    useEffect(() => {
        if (activeChips.length && itemsToShow >= 12) {
            setItemsToShow(employees.length);
            setIsExpanded(true);
        }
    }, [itemsToShow]);

    return (
        <div className={'team-employees-section flex'}>
            <div className={'team-employees'}>
                {employees.slice(0, itemsToShow).map((item, idx) => {
                    const size = 3;
                    let worksList = [];
                    if (item.fields) worksList = item.fields.works.slice(0, size);

                    return (
                        <AnimatePresence key={idx}>
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                className="keen-slider__slide"
                                onClick={() => setEmployeeData(employees, idx, onCycle)}>
                                <div className={'show-bg'}>
                                    <img
                                        className="keen-slider__slide-img"
                                        src={item.fields.image.fields.file.url}
                                        alt={item.fields.image.fields.title}
                                    />
                                    <div className={'hidden-item flex'}>
                                        {worksList.map((img, index) => {
                                            return (
                                                <div
                                                    className={'hidden-item__img-preview'}
                                                    key={index}>
                                                    <img
                                                        src={img.fields.image.fields.file.url}
                                                        alt={img.fields.image.fields.title}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className={'hidden-item__about'}>
                                        <p className={'hidden-item__position'}>
                                            {item.fields.position}
                                        </p>
                                        <p className={'hidden-item__name'}>{item.fields.title}</p>
                                    </div>
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    );
                })}
            </div>

            {employees.length <= 8 ? (
                ''
            ) : activeChips.length && itemsToShow >= 12 ? (
                <button onClick={() => showMore(8)} className={'btn-route'}>
                    {isExpanded ? 'Show Less' : 'Show More'}
                </button>
            ) : (
                <button
                    onClick={() => showMore(employees.length >= 12 ? 12 : 8)}
                    className={'btn-route'}>
                    {isExpanded ? 'Show Less' : 'Show More'}
                </button>
            )}
        </div>
    );
}

export default EmployeesList;
